import { de } from "./locales/de";

export const locales = ["de"] as const;
export const defaultLocale = "de";

export type Locale = (typeof locales)[number];

export const translations = {
  de,
};

export function getTranslations(locale: Locale) {
  return translations[locale] || translations[defaultLocale];
}
